<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :allow-edit="false"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                                 :config="config"
                                 ref="processExecution"
                                 @gotItems="setLocalVariables"
                                 :businessKey="$_emWorkflowTaskMixin_businessKey">
            </WorkflowProcessLine>

            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <WorkflowTaskComplete :task-id="$_emWorkflowTaskMixin_taskId"
                                      syncValueChange
                                      :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                      :config="config">
                </WorkflowTaskComplete>
            </div>
            <em-button type="downloadFile" @click="savePdf"
                       class="btn btn-outline-primary btn-sm position-absolute top right mt-1 mr-1"
                       style="z-index: 900"
                       v-if="!loadingPdf">
            </em-button>
        </section>
    </div>
</template>
<script>
// Author Lin
// Date 2022-05-06 20:09:47

import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete";
import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine";

export default {
    name: "sithMesPrdRoutingMaintainWorkflowTaskView",
    components: {WorkflowProcessLine, WorkflowTaskComplete},
    mixins: [emWorkflowTaskMixin, workflowTaskMixins],
    data() {
        return {
            htmlTitle: '导出PDF',
            loadingPdf: false
        }
    },
    methods: {
        savePdf() {
            this.loadingPdf = true;
            setTimeout(() => this.getPdf('#pdfDom'), 2000);
            setTimeout(() => this.loadingPdf = false, 5000);
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        $_emWorkflowTaskMixin_callbackApi() {
            return process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdRoutingMaintain/complete-feedback";
        },
        config() {
            return {
                'task1': {
                    tag: {},
                    name: '编制工艺路线并选择校对人审核人及特殊工艺',
                    variables: [
                        {
                            label: '维护或指派他人',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '自己维护'},
                                {value: 2, text: '指派他人'}
                            ],
                            changeTag: val => {
                                return this.buildTag('selfMaintain', val === 1);
                            }
                        },
                        {
                            needTag: 'selfMaintain',
                            label: '特殊工艺',
                            name: 'specialProcess',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.DATABASE,
                            options: [
                                {value: 1, text: '无'},
                                {value: 2, text: '编程'},
                                {value: 3, text: '焊接'},
                                {value: 4, text: '热处理'},
                            ],
                            require: true,
                            initData: true,
                        }
                    ],
                    postByApprove: (approve) => {
                        return {
                            url: process.env.VUE_APP_SITHMES_PRD_URL + `/sithMesPrdRoutingMaintain/notifySpecialProcess?taskId=${this.$_emWorkflowTaskMixin_businessKey}&approvedStatus=${approve}`,
                            data: {}
                        };
                    },
                    userSelectMap: {
                        2: [
                            {
                                name: 'task1_assignee',
                                require: true,
                                saveName: 'makerLogin',
                                saveToDatabase: true,
                            }
                        ],
                        1: [
                            {
                                name: 'task2_candidates',
                                allowMulti: true,
                                require: true,
                                labelWithout: '指派校对员'
                            },
                            {
                                name: 'task3_candidates',
                                allowMulti: true,
                                require: true,
                                labelWithout: '指派审核员'
                            }
                        ],
                    },
                    approveToNextTask: {
                        1: 'task2',
                        2: 'task1'
                    }
                },
                'task2': {
                    name: '校对工艺路线',
                    variables: [
                        {
                            label: '校对结果',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '通过'},
                                {value: 2, text: '退回'}
                            ],
                        }
                    ],
                    approveToNextTask: {
                        1: 'task3',
                        2: 'task1'
                    }
                },
                'task3': {
                    name: '审核工艺路线',
                    variables: [
                        {
                            label: '审核结果',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '通过'},
                                {value: 2, text: '退回'}
                            ],
                        }
                    ],
                    // userSelectMap: {
                    //     1: [
                    //         {
                    //             name: 'task4_candidates',
                    //             allowMulti: true,
                    //             require: true,
                    //         }
                    //     ],
                    // },
                    approveToNextTask: {
                        1: 'task4',
                        2: 'task1'
                    }
                },
                'task4': {
                    name: '转生产订单',
                    variables: [
                        {
                            label: '生产订单号',
                            name: 'ppHeaderId',
                            type: this.VALUE_TYPE.INPUT
                        }
                    ],
                    // userSelectMap: {
                    //     '*': [
                    //         {
                    //             name: 'task5_candidates',
                    //             saveName: 'drawingUploadLogin',
                    //             saveToDatabase: true,
                    //             require: true,
                    //         }
                    //     ],
                    // },
                    approveToNextTask: 'task5'
                },
                'task5': {
                    name: '上传图纸',
                    approveToNextTask: 'complete'
                },
                'complete': {
                    name: '流程结束'
                }
            }
        }
    }
};
</script>
<style scoped>
.pdf-width {
    width: 900px;
}
</style>
